// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-nav-filter-option {
  text-align: left;
  border-bottom: 1px solid #d0d7de;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.numberCircleUserCount {
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  color: #ffffff;
  display: inline-block;
  /* font-weight: bold; */
  line-height: 40px;
  margin-right: 6px;
  height: 24px;
  text-align: center;
  min-width: 24px;
  padding: 6px 6px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: "14px";
}

.side-nav-filter-option:hover {
  background-color: #f5f8fa;
}

.side-nav-filter-option-joined-active {
  border-left: #0076A8 4px solid;
}

.side-nav-filter-option-requested-active {
  border-left: #0076A8 4px solid;
}

.side-nav-filter-option-rejected-active {
  border-left: #0076A8 4px solid;
}

.side-nav-filter-option-removeRequested-active {
  border-left: #0076A8 4px solid;
}

.side-nav-filter-option-removed-active {
  border-left: #0076A8 4px solid;
}

.side-nav-filter-option.active {
  background-color: #f5f8fa;
}

.side-nav-filter-header {
  text-align: center;
  border-bottom: 1px solid #d0d7de;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrgHistory/components/SideNav/SideNav.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;AACf","sourcesContent":[".side-nav-filter-option {\n  text-align: left;\n  border-bottom: 1px solid #d0d7de;\n  padding: 10px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n}\n\n.numberCircleUserCount {\n  border-radius: 50%;\n  -moz-border-radius: 50%;\n  -webkit-border-radius: 50%;\n  color: #ffffff;\n  display: inline-block;\n  /* font-weight: bold; */\n  line-height: 40px;\n  margin-right: 6px;\n  height: 24px;\n  text-align: center;\n  min-width: 24px;\n  padding: 6px 6px;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: \"14px\";\n}\n\n.side-nav-filter-option:hover {\n  background-color: #f5f8fa;\n}\n\n.side-nav-filter-option-joined-active {\n  border-left: #0076A8 4px solid;\n}\n\n.side-nav-filter-option-requested-active {\n  border-left: #0076A8 4px solid;\n}\n\n.side-nav-filter-option-rejected-active {\n  border-left: #0076A8 4px solid;\n}\n\n.side-nav-filter-option-removeRequested-active {\n  border-left: #0076A8 4px solid;\n}\n\n.side-nav-filter-option-removed-active {\n  border-left: #0076A8 4px solid;\n}\n\n.side-nav-filter-option.active {\n  background-color: #f5f8fa;\n}\n\n.side-nav-filter-header {\n  text-align: center;\n  border-bottom: 1px solid #d0d7de;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
